// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../utils/images/contact-page-header.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page header {
    background-image: linear-gradient(rgba(5, 10, 35, 0.75), rgba(5, 10, 35, 0.75)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

#contact-form {
    width: 50%;
}

#contact-form .form-control:focus,
#contact-form .form-select:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, .25);
}

@media only screen and (max-width: 992px) {
    #contact-form {
        width: 75%;
    }
}

@media only screen and (max-width: 576px) {
    #contact-form {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Contact/Contact.css"],"names":[],"mappings":"AAAA;IACI,wHAAgI;AACpI;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".contact-page header {\n    background-image: linear-gradient(rgba(5, 10, 35, 0.75), rgba(5, 10, 35, 0.75)), url(../../utils/images/contact-page-header.jpg);\n}\n\n#contact-form {\n    width: 50%;\n}\n\n#contact-form .form-control:focus,\n#contact-form .form-select:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, .25);\n}\n\n@media only screen and (max-width: 992px) {\n    #contact-form {\n        width: 75%;\n    }\n}\n\n@media only screen and (max-width: 576px) {\n    #contact-form {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
